import axiosInstance from "../../translator";
import { workspaceManager as workspace } from "../../constants/apis/apiEndpoints";
import axios from "axios";
import { translator } from "../../constants/actionTypes";

export const fetchWorkspaceList = async (urlParams) => {
  return axiosInstance
    .get(`${workspace?.createWorkSpace}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createWorkspaceDashboard = async (urlParams) => {
  return axiosInstance
    .post(workspace?.createWorkSpace, urlParams)
    .then((response) => {
      return { data: response?.data, status: response?.status };
    })
    .catch((error) => {
      return error;
    });
};

export const editWorkspaceDashboard = async (urlParams) => {
  return axiosInstance
    .put(`${workspace?.createWorkSpace}/${urlParams.id}`, urlParams.payload)
    .then((response) => {
      return { data: response?.data, status: response?.status };
    })
    .catch((error) => {
      return error;
    });
};

export const deleteWorkspaceDashboard = async (urlParams) => {
  return axiosInstance
    .delete(`${workspace?.createWorkSpace}/${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createWorkspaceRequest = async (data) => {
  return axiosInstance
    .post(`${workspace?.createWorkSpace}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const editWorkSpaceRequest = async (payload) => {
  return axiosInstance
    .put(`${workspace?.createWorkSpace}/${payload?.workspaceId}`, payload?.payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createResourceRequest = async (payload) => {
  return axiosInstance
    .post(`${workspace?.createResource}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const editResourceRequest = async (params) => {
  return axiosInstance
    .put(`${workspace?.createResource}/${params?.workspace_id}`, params?.payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
export const addAuthRequest = async (payload) => {
  return axiosInstance
    .post(`${workspace?.authConfig}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const editAuthRequest = async (params) => {
  return axiosInstance
    .put(`${workspace?.authConfig}/${params?.workspaceId}`, params?.payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getResourceTemplatesRequest = async (params) => {
  return axiosInstance
    .get(`${workspace?.resourceTemplates}${params}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const retrieveWorkspace = async (urlParams) => {
  return axiosInstance
    .get(`${workspace?.createWorkSpace}/${urlParams}?details=true`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getWorkspaceDetailsUsers = async (id, urlParams) => {
  return axiosInstance
    .get(`${workspace?.workspaceUsers}?workspace_id=${id}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteWorkspaceUserInvitation = async (urlParams) => {
  return axiosInstance
    .delete(`${workspace?.workspaceUsers}/${urlParams}}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getWorkSpaceById = async (urlParams) => {
  return axiosInstance
    .get(`${workspace?.createWorkSpace}/${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getInstanceAndPricing = async (urlParams) => {
  return axiosInstance
    .get(`${workspace?.instanceSizePricing}/${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getResourceByIdRequest = async (urlParams) => {
  return axiosInstance
    .get(`${workspace?.createResource}/${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getAuthConfigByIdRequest = async (urlParams) => {
  return axiosInstance
    .get(`${workspace?.authConfig}/${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const workspaceActionHandler = async (payload) => {
  return axiosInstance
    .patch(`${workspace?.workspaceAction}/${payload?.id}`, payload?.data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchWorkspaceResourceList = async (data) => {
  return axiosInstance
    .get(`${workspace?.workspaceResource}/${data?.id}${data?.urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchPublicWorkspaceResourceList = async (data) => {
  return axiosInstance
    .get(`/v1/cloud-lab${data?.urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const linkDelinkRequest = async (data) => {
  return axiosInstance
    .post(`${workspace?.linkDelink}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const listUserInvitationRequest = async (params) => {
  return axiosInstance
    .get(`${workspace?.listUserInivitation}${params}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const downloadInvitationCsv = async (urlParams) => {
  return axiosInstance
    .post(`${workspace?.workspaceInvitation}?workspace_id=${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const resendInvitationApi = async (payload) => {
  return axiosInstance
    .post(`${workspace?.resendInvitation}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const generateInviteUrlRequest = async (payload) => {
  return axiosInstance
    .post(`${workspace?.getInvitationLink}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getWorkspaceTenantList = async (payload) => {
  return axiosInstance
    .get(`${workspace?.getWorkspaceTenants}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getWorkspaces = async (payload, params = {}) => {
  return axiosInstance
    .get(`${workspace?.getWorkspaces}/${payload}`, {
      params: params
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getPreviousUsageReports = async (urlParams) => {
  return axiosInstance
    .get(`${workspace?.usageReports}${urlParams}&workspace=true`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const generateReport = async (payload) => {
  let url = payload?.workspace_id ? `${workspace?.usageReports}?wid=${payload?.workspace_id}` : `${workspace?.usageReports}`;
  return axiosInstance
    .post(url, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getInvitationApi = async (payload) => {
  return axios
    .post(`${translator?.baseURL}${workspace?.getInvitation}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getExtendWorkspacePacksRequest = async (payload) => {
  return axiosInstance
    .get(`${translator?.baseURL}${workspace?.extend}/${payload}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getWorkspaceAuthData = async (payload) => {
  return axiosInstance
    .get(`${translator?.baseURL}${workspace?.getWorkSpaceAuthResponse}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const checkVmExtendQuotaWorkspaceLogin = async (payload = "") => {
  const vmQuota = axiosInstance
    .get(`${workspace?.checkVMExtendQuota}${payload}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return vmQuota;
};

export const workspaceExtsnVldtyUpdateApi = async (data) => {
  return axiosInstance
    .post(`${workspace.updateQuota}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createVmApiWorkspace = async (data) => {
  return axiosInstance
    .post(`${workspace?.createQuota}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchTenantListForWorkspace = async (payload) => {
  return axiosInstance
    .get(`${workspace?.tenantListForWorkspace}${payload}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const workspaceAddUserApi = async (data) => {
  return axiosInstance
    .post(`${workspace?.workspaceUser}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const workspaceEditUserApi = async (id, data) => {
  return axiosInstance
    .put(`${workspace?.workspaceUser}/${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const addWorkspaceResourceApi = async (data) => {
  return axiosInstance
    .post(`${workspace?.addWorkspaceResources}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getAllSkuCloudVMApi = async () => {
  return axiosInstance
    .get(`${workspace?.getAllSkuCloudVM}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getAllInstanceCloudVMApi = async (params) => {
  return axiosInstance
    .get(`${workspace?.getAllSkuCloudVM}${params}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};